export default __webpack_public_path__ + "static/media/98.79bc0a33.jpg";